import { isMobile } from "../util/Breakpoint";
import tracker from "../tracking/Tracker";
import { triggerSizePreferencesUpdate } from "../nextBestAction/sizePreferencesStore";
import { SizePreferencesCookieStore } from "@otto-ec/heureka-components/facet";
import { heureka } from "@otto-ec/heureka";
import { deriveParentStatusFromChildren, extractFeatureFromElement } from "../filter/FilterTracking";
import { listFeatures } from "../tracking/FeatureTracking";
import type { Feature } from "../tracking/Tracking";

export function registerFilterPersonalizationEventHandlers() {
  if (isMobile()) {
    heureka.filterPersonalization_saved.on(() => {
      triggerSizePreferencesUpdate();
    });
    heureka.filterPersonalization_deleted.on(() => {
      triggerSizePreferencesUpdate();
    });
    heureka.filterPersonalization_track.on((event) => {
      trackFilterPersonalization(event.action, event.facetId, event.values, event.remainingSavedValues);
    });
  }
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function trackFilterPersonalization(
  action: "save" | "delete" | "delete_all" | "undo_delete",
  facetId: string,
  valueIds: string[],
  remainingSavedValueIds?: string[],
) {
  const facetActivityMap = {
    save: "save_facet_value",
    delete: "delete_saved_facet_value",
    delete_all: "delete_all_saved_facet_values",
    undo_delete: "delete_all_saved_undo",
  } as const;

  const facetActivity = facetActivityMap[action];

  /*                                           */
  const facetElement = document.getElementById(`facet_${facetId}`);
  const facetName = facetElement?.getAttribute("name") || facetId;

  /*                                                      */
  const filterForm = facetElement?.closest("form");

  const additionalLabels = {
    san_FacetActivity: facetActivity,
    san_FacetActivityType: facetName,
    "wk.san_SavedFacetValues": SizePreferencesCookieStore.toString(),
  };

  /*                                                                  */
  /*                                                                                           */
  const facetValueFeatures: Feature[] = [];
  const addedValueIds = new Set<string>();

  /*                                      */
  for (const valueId of valueIds) {
    if (addedValueIds.has(valueId)) continue;
    const valueElement = document.getElementById(valueId);
    if (valueElement?.dataset.tsFeatureName === "Facet-Value") {
      const valueFeature = extractFeatureFromElement(valueElement);
      if (valueFeature) {
        facetValueFeatures.push(valueFeature);
        addedValueIds.add(valueId);
      }
    }
  }

  /*                                                      */
  if (remainingSavedValueIds) {
    for (const valueId of remainingSavedValueIds) {
      if (addedValueIds.has(valueId)) continue;
      const valueElement = document.getElementById(valueId);
      if (valueElement?.dataset.tsFeatureName === "Facet-Value") {
        const valueFeature = extractFeatureFromElement(valueElement);
        if (valueFeature) {
          facetValueFeatures.push(valueFeature);
          addedValueIds.add(valueId);
        }
      }
    }
  }

  /*                                                                */
  const combinedStatus = deriveParentStatusFromChildren(facetValueFeatures.map((f) => f.status));

  /*                                                                                      */
  const features = [...listFeatures(["Filter-Overview"])];

  /*                                     */
  if (filterForm && filterForm.id) {
    const filterElement = document.getElementById(filterForm.id);
    if (filterElement?.dataset.tsFeatureName === "Filter") {
      const filterFeature = extractFeatureFromElement(filterElement);
      if (filterFeature) {
        filterFeature.status = combinedStatus;
        features.push(filterFeature);
      }
    }
  }

  /*                                                 */
  if (facetElement?.dataset.tsFeatureName === "Facet") {
    const facetFeature = extractFeatureFromElement(facetElement);
    if (facetFeature) {
      facetFeature.status = combinedStatus;
      features.push(facetFeature);
    }
  }

  /*                       */
  features.push(...facetValueFeatures);

  tracker.submitAction(additionalLabels, {
    name: "click",
    features,
  });
}
